import script from "./Exam.vue?vue&type=script&setup=true&lang=ts"
export * from "./Exam.vue?vue&type=script&setup=true&lang=ts"

import "./Exam.vue?vue&type=style&index=0&id=1432e7d4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1432e7d4"]])

export default __exports__